import { NominationFormContext } from '@percent/grants-nomination-form/context/nominationForm/NominationFormContext';
import { useContext } from 'react';

export const useNominationForm = () => {
  const context = useContext(NominationFormContext);

  if (context === undefined) {
    throw new Error('useNominationForm must be used within a NominationFormContextController');
  }

  return context;
};
